import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const fetchLeasingCompanies = createAction(types.FETCH_LEASING_COMPANIES);
export const fetchLeasingCompaniesSuccess = createAction(types.FETCH_LEASING_COMPANIES_SUCCESS);
export const fetchLeasingCompaniesFailure = createAction(types.FETCH_LEASING_COMPANIES_FAILURE);
